import { Controller } from "@hotwired/stimulus"

// Warn before discarding edits. A successful save empties the frame directly
// (turbo_stream.update "modal", "") rather than going through close(), so this
// only fires on the explicit close paths below.
const DISCARD_MESSAGE = "Er zijn wijzigingen die nog niet opgeslagen zijn. Wil je dit venster sluiten?"

// User-driven events that bubble to the dialog. Native "input" covers typing
// (including in Trix's contenteditable); "trix-change" is intentionally absent
// since it can fire on initial content load and falsely mark the form dirty.
const DIRTY_EVENTS = ["input", "change", "cropend"]

// Drives a <dialog> loaded into the #modal turbo-frame: opens it on connect,
// closes on backdrop click (guarding unsaved edits), and empties the frame once
// closed so it can be reused.
export default class extends Controller {
  connect() {
    if (this.element.tagName === "DIALOG" && !this.element.open) {
      this.element.showModal()
    }

    this.dirty = false
    this.markDirty = () => { this.dirty = true }
    DIRTY_EVENTS.forEach((evt) => this.element.addEventListener(evt, this.markDirty))

    // Escape fires a cancelable "cancel" before the dialog closes; veto it when
    // the user backs out of the discard prompt.
    this.onCancel = (event) => { if (!this.confirmDiscard()) event.preventDefault() }
    this.element.addEventListener("cancel", this.onCancel)
  }

  disconnect() {
    DIRTY_EVENTS.forEach((evt) => this.element.removeEventListener(evt, this.markDirty))
    this.element.removeEventListener("cancel", this.onCancel)
  }

  close() {
    if (this.confirmDiscard()) this.element.close()
  }

  // The explicit "Cancel" button: a deliberate discard, so skip the prompt.
  discard() {
    this.dirty = false
    this.element.close()
  }

  // A click whose target is the dialog itself landed on the ::backdrop.
  backdropClose(event) {
    if (event.target === this.element && this.confirmDiscard()) this.element.close()
  }

  confirmDiscard() {
    return !this.dirty || window.confirm(DISCARD_MESSAGE)
  }

  cleanup() {
    const frame = this.element.closest("turbo-frame")
    if (frame) frame.innerHTML = ""
  }
}
